{
  "version": 1,
  "asset_id": "05e194a3-20e3-4fde-823e-95d99dcd35e1",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/05e194a3-20e3-4fde-823e-95d99dcd35e1/author-wietse-van-koppen.jpg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/05e194a3-20e3-4fde-823e-95d99dcd35e1/author-wietse-van-koppen.jpg",
  "original_filename": "author-wietse-van-koppen.jpg",
  "size": 61970,
  "content_type": "image/jpeg",
  "created_at": "2026-08-30T14:15:10Z"
}
